import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import LogoImage from "../../images/WhatsAppBulkSend.svg";
import NoIndex from "../NoIndex";
import "./Login.css";
import MyContext from "../../MyContext";
import GoogleOneTap from "../Googleonetab";

const LoginPage = () => {
  const { baseUrl, config, config2 } = useContext(MyContext);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState(null);
  const [MobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [MobileNumberError, setMobileNumberError] = useState("");
  const [Otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [step, setstep] = useState(1);
  const [OTPField, setOTPField] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [Lerror, setLerror] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [LoginScreen, setLoginScreen] = useState("LOGIN");
  const [User, setUser] = useState("no user");

  const [ForgetNumber, setForgetNumber] = useState("");
  const [ForgetStep, setForgetStep] = useState(1);
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmNewPassword, setConfirmNewPassword] = useState("");
  const [ForgetOtp, setForgetOtp] = useState(["", "", "", "", "", ""]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  function validateInputs() {
    if (MobileNumber.length !== 10) {
      toast.error("Invalid Mobile number");
    } else if (!password) {
      toast.error("Please enter your password");
    } else {
      LoginCall();
    }
  }

  // Function to send OTP (step 1)
  const sendOtp = async () => {
    try {
      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: "1", // step 1 for sending OTP
        otp: "", // OTP is empty for step 1
        latitude: "",
        longitude: "",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("OTPVERIFICATION");
        setstep(2);
        setOTPField(true);
      } else if (response.data.responseCode === "01") {
        toast.error(response.data.responseMessage);
        setError(true);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error sending OTP");
      console.error("Error sending OTP:", error);
    }
  };

  // Function to verify OTP (step 2)
  const verifyOtp = async () => {
    try {
      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: "2",
        otp: Otp.join(""),
        latitude: "",
        longitude: "",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        sessionStorage.setItem("user", JSON.stringify(response.data.response));
        setUser(true);
        await subscriptionDetailsApi(response.data.response.userid);
        await allowedServicesAPI(response.data.response.userid);
        window.location.href = "/Dashboard";
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error("Error during OTP verification:", error);
    }
  };

  const allowedServicesAPI = async (userId) => {
    try {
      const requestBody = { userid: userId };
      const response = await axios.post(
        `${baseUrl}/api/User/getUserAccess`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        sessionStorage.setItem(
          "menuItems",
          JSON.stringify(response.data.response)
        );
      } else {
        console.log("Failed to get user access");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const subscriptionDetailsApi = async (userId) => {
    try {
      const responseBody = {
        userid: userId,
      };
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/fetchSubscriptionDetails`,
        responseBody,
        config
      );
      if (response.data.responseCode === "00") {
        sessionStorage.setItem("power", "1");
        if (process.env.NODE_ENV === "development") {
          window.location.href = "/Dashboard";
        } else {
          window.location.href = "/Dashboard";
        }
      } else if (response.data.responseCode === "03") {
        if (process.env.NODE_ENV === "development") {
          window.location.href = "/Dashboard";
        } else {
          window.location.href = "/Dashboard";
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Main Login function
  const LoginCall = async () => {
    if (MobileNumber.length !== 10) {
      toast.error("Invalid Mobile number");
      return;
    }
    if (!password) {
      toast.error("Please enter your password");
      return;
    }

    try {
      const BankData = {
        mobile: MobileNumber,
        password: password,
        latitude: latitude || "",
        longitude: longitude || "",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v2.0/userLogin`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        sessionStorage.setItem("user", JSON.stringify(response.data.response));
        setUser(true);
        await subscriptionDetailsApi(response.data.response.userid);
        await allowedServicesAPI(response.data.response.userid);
        window.location.href = "/Dashboard";
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error during login");
      console.error("Error during login:", error);
    }
  };

  const ResendOtp = async (step) => {
    toast.info("Resending OTP...");

    try {
      const BankData = {
        mobile: MobileNumber,
        password: password,
        step: 1,
        otp: Otp.join(""),
        latitude: latitude,
        longitude: longitude,
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1/userLogin`,
        BankData,
        config2
      );
      if (step === "1") {
        toast.success(response.data.responseMessage);
        setUser(response.data.response);
        setstep(2);
        setOTPField(true);
      } else if (step === "2") {
        setUser(response.data.response);
        sessionStorage.setItem("power", "1");
        if (process.env.NODE_ENV === "development") {
          window.location.href = "/Dashboard";
        } else {
          window.location.href = "/Dashboard";
        }
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error");
      console.error("Error updating Admin login:", error);
    }
  };

  const handleOtpChange = (element, index) => {
    if (isNaN(element.value)) return false;

    const newOtp = [...Otp];
    newOtp[index] = element.value;
    setOtp(newOtp);

    if (element.value !== "" && element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...Otp];
      newOtp[index] = "";
      setOtp(newOtp);

      if (index > 0) {
        const prevInput = e.target.previousSibling;
        prevInput.focus();
      }
    }
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => {
          setLerror(err.message);
        }
      );
    } else {
      setError("Geolocation is not supported by your browser");
    }
  }, []);

  const handleForgotOtpChange = (element, index) => {
    if (isNaN(Number(element.value))) return;

    const newOtp = [...ForgetOtp];
    newOtp[index] = element.value;
    setForgetOtp(newOtp);

    if (element.value !== "" && element.nextElementSibling) {
      element.nextElementSibling.focus();
    }

    if (element.value === "" && element.previousElementSibling) {
      element.previousElementSibling.focus();
    }
  };

  const sendForgetOtp = async () => {
    try {
      const BankData = {
        mobile: ForgetNumber,
        newPassword: "",
        otp: "",
        step: "1",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("OTPVERIFICATIONFORGET");
        setForgetStep(2);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error sending OTP");
      console.error("Error sending OTP:", error);
    }
  };

  const verifyForgetOtp = async () => {
    try {
      const BankData = {
        mobile: ForgetNumber,
        newPassword: "",
        otp: ForgetOtp.join(""),
        step: "2",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setLoginScreen("RESET_PASSWORD");
        setForgetStep(3);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error verifying OTP");
      console.error("Error verifying OTP:", error);
    }
  };

  const resetPassword = async () => {
    if (NewPassword !== ConfirmNewPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      const BankData = {
        mobile: ForgetNumber,
        newPassword: NewPassword,
        otp: ForgetOtp.join(""),
        step: "3",
      };

      const response = await axios.post(
        `${baseUrl}/api/User/v1.0/forgetPassword`,
        BankData,
        config2
      );

      if (response.data.responseCode === "00") {
        toast.success("Password reset successfully!");
        setLoginScreen("LOGIN");
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error resetting password");
      console.error("Error resetting password:", error);
    }
  };

  function ForgotPassWord() {
    setLoginScreen("FORGOTPASSWORD");
  }

  const getStepLabel = () => {
    if (LoginScreen === "LOGIN") return "Login";
    if (LoginScreen === "OTPVERIFICATION") return "Login OTP";
    if (LoginScreen === "FORGOTPASSWORD") return "Forgot password";
    if (LoginScreen === "OTPVERIFICATIONFORGET") return "Verify OTP";
    if (LoginScreen === "RESET_PASSWORD") return "Reset password";
    return "";
  };
const handleGoogleResponse = async (response) => {
    try {
      const credential = response.credential;
      if (!credential) return;


      const base64Url = credential.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const decodedData = JSON.parse(atob(base64));

      const googleUser = {
        name: decodedData.name,
        email: decodedData.email,
        picture: decodedData.picture,
        google_id: decodedData.sub, // IMPORTANT
      };

      const [firstName, ...rest] = googleUser.name.split(" ");
      const lastName = rest.join(" ");

      const basicAuth = btoa("BUMPPY_SSO_SgLjvARJ5LbX:tGhAlPHEkx1McBnkw43vXUXs44i744jQbbjU1ODHB5SIRtSDFYaYF1yeGFJBYlZq");

      const registerResponse = await fetch(
        "https://auth.seobix.com/api/Auth/register2",
        {
          method: "POST",
          headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
            "Authorization": `Basic ${basicAuth}`,
          },
          body: JSON.stringify({
            username: googleUser.email,
            password: googleUser.google_id, // or any generated value
            firstName:googleUser.name,
            lastName:googleUser.name,
            dob: "",
            gender: "",
            country: "91",
            latitude: "",
            longitude: "",
            device: "web",
            callback: "",
            productId: "1",
            login_with: "google",
            google_id: googleUser.google_id,
            display_img:googleUser.picture,
          }),
        }
      );

      const registerData = await registerResponse.json();
      console.log("Register API:", registerData);

      // ❗ API returns 200 but status=401 in body
      if (registerData.status === "401") {
        console.warn("User already exists or unauthorized, continuing login");
      }

      // =========================
      // 2️⃣ IDENTITY / LOGIN API
      // =========================
      const identityResponse = await fetch(
        "https://auth.seobix.com/api/Auth/identityGoogle",
        {
          method: "POST",
          headers: {
            "Accept": "*/*",
            "Content-Type": "application/json-patch+json",
             "Authorization": `Basic ${basicAuth}`,
          },
          body: JSON.stringify({
            email: googleUser.email,
            latitude: null,
            longitude: null,
            device: "web",
            country: "+91",
            productId: "8",
            callback: null,
          }),
        }
      );

      const identityData = await identityResponse.json();
      console.log("Identity API:", identityData);


      localStorage.setItem("accessToken", identityData.accessToken);
      localStorage.setItem("refreshToken", identityData.refreshToken);
      localStorage.setItem("userId", identityData.userId);


      if (window.google?.accounts?.id) {
        window.google.accounts.id.cancel();
      }

      const urlParams = new URLSearchParams(window.location.search);
      const callbackUrl = urlParams.get("callback");

      if (callbackUrl && identityData?.accessToken) {
        const url = new URL(callbackUrl);

        url.searchParams.set("accessToken", identityData.accessToken);



        window.location.href = url.toString();
      }

    } catch (err) {
      console.error("Google Login Error:", err);
    }
  };
  return (
    <div className="wbs-minimal-page">
      <NoIndex />
      <ToastContainer position="top-center" />

      <div className="wbs-minimal-card">
        {/* Logo + Title */}
        <div className="wbs-minimal-header">
          <div className="wbs-minimal-logo">
            <img src={LogoImage} alt="WhatsAppBulkSend" />
          </div>
          <span className="wbs-minimal-step-pill">{getStepLabel()}</span>
          <h1 className="wbs-minimal-heading">
            {LoginScreen === "LOGIN" && "Welcome back 👋"}
            {LoginScreen === "OTPVERIFICATION" && "Verify your login"}
            {LoginScreen === "FORGOTPASSWORD" && "Forgot your password?"}
            {LoginScreen === "OTPVERIFICATIONFORGET" && "Verify OTP"}
            {LoginScreen === "RESET_PASSWORD" && "Set a new password"}
          </h1>
          <p className="wbs-minimal-sub">
            {LoginScreen === "LOGIN" &&
              "Sign in to manage and send your WhatsApp campaigns."}
            {LoginScreen === "OTPVERIFICATION" &&
              "Enter the 6-digit code sent to your registered number."}
            {LoginScreen === "FORGOTPASSWORD" &&
              "Enter your registered mobile number to receive an OTP."}
            {LoginScreen === "OTPVERIFICATIONFORGET" &&
              "Enter the OTP we sent to your phone to continue."}
            {LoginScreen === "RESET_PASSWORD" &&
              "Create a strong, secure password for your account."}
          </p>
        </div>

        {/* LOGIN */}
        {LoginScreen === "LOGIN" && (
          <form
            className="wbs-minimal-form"
            onSubmit={(e) => e.preventDefault()}
          >
            <label className="wbs-minimal-label">Phone number</label>
            <div className="wbs-minimal-input-group">
              <select className="wbs-minimal-country">
                <option value="+91">+91</option>
              </select>
              <input
                type="tel"
                className={`wbs-minimal-input ${
                  error ? "wbs-minimal-invalid" : ""
                }`}
                placeholder="Enter phone number"
                value={MobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
            </div>

            <label className="wbs-minimal-label">Password</label>
            <div className="wbs-minimal-input-group">
              <input
                type={showPassword ? "text" : "password"}
                className="wbs-minimal-input"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="wbs-minimal-text-btn wbs-minimal-toggle"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>

            <div className="wbs-minimal-row-between">
              <button
                type="button"
                className="wbs-minimal-text-btn"
                onClick={() => setLoginScreen("FORGOTPASSWORD")}
              >
                Forgot password?
              </button>
            </div>

            <button
              type="button"
              onClick={validateInputs}
              className="wbs-minimal-primary-btn"
            >
              Continue
            </button>
          </form>
        )}
<div className="mt-1">
                    <GoogleOneTap onSuccess={handleGoogleResponse} />
                  </div>

        {/* LOGIN OTP VERIFICATION */}
        {LoginScreen === "OTPVERIFICATION" && (
          <form
            className="wbs-minimal-form"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="wbs-minimal-otp-row">
              {Otp.map((data, index) => (
                <input
                  className="wbs-minimal-otp-input"
                  type="text"
                  name="otp"
                  maxLength="1"
                  key={index}
                  value={data}
                  onChange={(e) => handleOtpChange(e.target, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                />
              ))}
            </div>

            <button
              type="button"
              onClick={LoginCall}
              className="wbs-minimal-primary-btn"
            >
              Continue
            </button>

            <button
              type="button"
              onClick={ResendOtp}
              className="wbs-minimal-secondary-btn"
            >
              Re-send OTP
            </button>
          </form>
        )}

        {/* FORGOT PASSWORD */}
        {LoginScreen === "FORGOTPASSWORD" && (
          <form
            className="wbs-minimal-form"
            onSubmit={(e) => e.preventDefault()}
          >
            <label className="wbs-minimal-label">Phone number</label>
            <div className="wbs-minimal-input-group">
              <select className="wbs-minimal-country">
                <option value="+91">+91</option>
              </select>
              <input
                type="tel"
                className={`wbs-minimal-input ${
                  error ? "wbs-minimal-invalid" : ""
                }`}
                placeholder="Enter phone number"
                value={ForgetNumber}
                onChange={(e) => setForgetNumber(e.target.value)}
              />
            </div>

            <button
              type="button"
              onClick={sendForgetOtp}
              className="wbs-minimal-primary-btn"
            >
              Send OTP
            </button>

            <button
              type="button"
              className="wbs-minimal-text-btn wbs-minimal-back"
              onClick={() => setLoginScreen("LOGIN")}
            >
              ← Back to login
            </button>
          </form>
        )}

        {/* FORGOT PASSWORD OTP VERIFICATION */}
        {LoginScreen === "OTPVERIFICATIONFORGET" && (
          <form
            className="wbs-minimal-form"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="wbs-minimal-otp-row">
              {ForgetOtp.map((data, index) => (
                <input
                  className="wbs-minimal-otp-input"
                  type="text"
                  name="otp"
                  maxLength="1"
                  key={index}
                  value={data}
                  onChange={(e) => handleForgotOtpChange(e.target, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                />
              ))}
            </div>

            <button
              type="button"
              onClick={verifyForgetOtp}
              className="wbs-minimal-primary-btn"
            >
              Continue
            </button>
          </form>
        )}

        {/* RESET PASSWORD */}
        {LoginScreen === "RESET_PASSWORD" && (
          <form
            className="wbs-minimal-form"
            onSubmit={(e) => e.preventDefault()}
          >
            <label className="wbs-minimal-label">New password</label>
            <div className="wbs-minimal-input-group">
              <input
                type="password"
                className="wbs-minimal-input"
                placeholder="New password"
                value={NewPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>

            <label className="wbs-minimal-label">Confirm new password</label>
            <div className="wbs-minimal-input-group">
              <input
                type="password"
                className="wbs-minimal-input"
                placeholder="Confirm new password"
                value={ConfirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
              />
            </div>

            <button
              type="button"
              onClick={resetPassword}
              className="wbs-minimal-primary-btn"
            >
              Reset password
            </button>
          </form>
        )}

        <div className="wbs-minimal-footer-text">
          Secure login • Encrypted • Location enabled
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
